import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { Observable } from 'rxjs';
import { Checkup } from './store';
import { tap, map } from 'rxjs/operators';
import { Guid } from '../shared';

@Injectable({
    providedIn: 'root',
})
export class CheckupService {
    private uri = `${environment.apiLocation}/eFCheckup`;

    constructor(private http: HttpClient, private log: LoggingService) {}

    public get(
        ProcessID?: number,
        EmployeeListID?: string
    ): Observable<Array<Checkup>> {
        this.log.verbose({ type: 'CheckupService:get', ProcessID });
        const _uri = !!ProcessID
            ? `${this.uri}/?EmployeeListID=${EmployeeListID}&ProcessID=${ProcessID}`
            : `${this.uri}/?EmployeeListID=${EmployeeListID}`;
        return this.http.get<Array<Checkup>>(_uri).pipe(
            tap((data) => this.log.verbose({ type: 'getCheckup', data })),
            map((checkups) =>
                checkups.map((x) => ({ ...x, id: Guid.newGuid() }))
            )
        );
    }
}
